var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "loginPage", staticClass: "login-page", attrs: { id: "loginPage" } },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading"
          }
        ],
        staticClass: "loading-page center"
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading,
              expression: "!isLoading"
            }
          ]
        },
        [
          _c("div", { staticClass: "login-header" }, [
            _c("div", { staticClass: "logo font-12" }, [
              _c("div", [
                _c("img", {
                  attrs: { src: require("@/assets/images/logo.png") }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "line-vert" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("localSessionStorage.logoTitle")))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.isStorageDisabled
            ? _c("div", [
                _c("h2", { staticClass: "heading-alert" }, [
                  _vm._v(_vm._s(_vm.$t("localSessionStorage.enableStorageDOM")))
                ]),
                _vm._v(" "),
                _c("h5", { staticClass: "instruction" }, [
                  _vm._v(
                    "\r\n                " +
                      _vm._s(_vm.pathToActivateStorage) +
                      "\r\n            "
                  )
                ])
              ])
            : _c("div", { staticClass: "form-body container" }, [
                _c("ul", { staticClass: "nav nav-tabs row" }, [
                  _c("li", { staticClass: "nav-item col" }, [
                    _c(
                      "span",
                      {
                        class: ["nav-link", { active: _vm.isDigitalTab }],
                        on: {
                          click: function($event) {
                            _vm.changeTab(_vm.AuthorizationType.DigitalKey)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\r\n                        " +
                            _vm._s(_vm.$t("login.digitalSignatureTab")) +
                            "\r\n                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "nav-item col" }, [
                    _c(
                      "span",
                      {
                        class: ["nav-link", { active: _vm.isLoginTab }],
                        on: {
                          click: function($event) {
                            _vm.changeTab(_vm.AuthorizationType.Login)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\r\n                        " +
                            _vm._s(_vm.$t("login.loginTab")) +
                            "\r\n                    "
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-aria row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isDigitalTab,
                            expression: "isDigitalTab"
                          }
                        ],
                        ref: "tabDigitalBody",
                        attrs: { id: "tabDigitalBody" },
                        on: {
                          keyup: function($event) {
                            if (
                              !("button" in $event) &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.loginUserDigitalSignature($event)
                          }
                        }
                      },
                      [
                        _vm.msgError
                          ? _c("div", { staticClass: "alert-msg" }, [
                              _c(
                                "div",
                                {
                                  ref: "msgError",
                                  staticClass:
                                    "alert position-relative alert-danger alert-dismissible",
                                  attrs: { role: "alert" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "row w-100 word-break" },
                                    [_vm._v(" " + _vm._s(_vm.msgError) + " ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "close",
                                      attrs: {
                                        href: "#",
                                        "data-dismiss": "alert",
                                        "aria-label": "close"
                                      }
                                    },
                                    [_vm._v("×")]
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.container,
                                    expression: "container"
                                  }
                                ],
                                ref: "container",
                                staticClass: "form-control",
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.container = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "",
                                      selected: "",
                                      hidden: ""
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("login.container")))]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.containerList, function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "option",
                                    { domProps: { value: item.name } },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                })
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-auto pl-0" }, [
                            _c("span", {
                              staticClass: "refresh-icon",
                              on: { click: _vm.updateKeyContainerNames }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group" }, [
                          (_vm.isPasswordDigitalVisible
                            ? "text"
                            : "password") === "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.passwordDigitalSignature,
                                    expression: "passwordDigitalSignature"
                                  }
                                ],
                                ref: "passwordDigitalSignature",
                                staticClass: "form-control",
                                class: { "is-invalid": _vm.msgError },
                                attrs: {
                                  name: "passwordDigitalSignature",
                                  placeholder: _vm.$t("login.passwordPlace"),
                                  type: "checkbox"
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.passwordDigitalSignature
                                  )
                                    ? _vm._i(
                                        _vm.passwordDigitalSignature,
                                        null
                                      ) > -1
                                    : _vm.passwordDigitalSignature
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.passwordDigitalSignature,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.passwordDigitalSignature = $$a.concat(
                                            [$$v]
                                          ))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.passwordDigitalSignature = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.passwordDigitalSignature = $$c
                                    }
                                  }
                                }
                              })
                            : (_vm.isPasswordDigitalVisible
                                ? "text"
                                : "password") === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.passwordDigitalSignature,
                                    expression: "passwordDigitalSignature"
                                  }
                                ],
                                ref: "passwordDigitalSignature",
                                staticClass: "form-control",
                                class: { "is-invalid": _vm.msgError },
                                attrs: {
                                  name: "passwordDigitalSignature",
                                  placeholder: _vm.$t("login.passwordPlace"),
                                  type: "radio"
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.passwordDigitalSignature,
                                    null
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.passwordDigitalSignature = null
                                  }
                                }
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.passwordDigitalSignature,
                                    expression: "passwordDigitalSignature"
                                  }
                                ],
                                ref: "passwordDigitalSignature",
                                staticClass: "form-control",
                                class: { "is-invalid": _vm.msgError },
                                attrs: {
                                  name: "passwordDigitalSignature",
                                  placeholder: _vm.$t("login.passwordPlace"),
                                  type: _vm.isPasswordDigitalVisible
                                    ? "text"
                                    : "password"
                                },
                                domProps: {
                                  value: _vm.passwordDigitalSignature
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.passwordDigitalSignature =
                                      $event.target.value
                                  }
                                }
                              }),
                          _vm._v(" "),
                          _vm.passwordDigitalSignature
                            ? _c("div", { staticClass: "input-group-append" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline eye",
                                    attrs: { type: "button" },
                                    on: {
                                      click: _vm.changePasswordDigitalVisibile
                                    }
                                  },
                                  [
                                    _vm.isPasswordDigitalVisible
                                      ? _c("font-awesome-icon", {
                                          attrs: { icon: "eye" }
                                        })
                                      : _c("font-awesome-icon", {
                                          attrs: { icon: "eye-slash" }
                                        })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "enter-button row w-100",
                            attrs: {
                              disabled: _vm.disabledLoginDigitalSignature,
                              type: "button"
                            },
                            on: { click: _vm.loginUserDigitalSignature }
                          },
                          [
                            _vm._v(
                              "\r\n                            " +
                                _vm._s(_vm.$t("login.button")) +
                                "\r\n                        "
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isLoginTab,
                            expression: "isLoginTab"
                          }
                        ],
                        ref: "tabLoginBody",
                        attrs: { id: "tabLoginBody" },
                        on: {
                          keyup: function($event) {
                            if (
                              !("button" in $event) &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.loginUser($event)
                          }
                        }
                      },
                      [
                        _vm.msgError
                          ? _c("div", { staticClass: "alert-msg" }, [
                              _c(
                                "div",
                                {
                                  ref: "msgError",
                                  staticClass:
                                    "alert position-relative alert-danger alert-dismissible",
                                  attrs: { role: "alert" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "row w-100 word-break" },
                                    [_vm._v(" " + _vm._s(_vm.msgError) + " ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "close",
                                      attrs: {
                                        href: "#",
                                        "data-dismiss": "alert",
                                        "aria-label": "close"
                                      }
                                    },
                                    [_vm._v("×")]
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userName,
                              expression: "userName"
                            }
                          ],
                          ref: "login",
                          staticClass: "form-control w-100",
                          class: { "is-invalid": _vm.msgError },
                          attrs: {
                            type: "text",
                            name: "login",
                            placeholder: _vm.$t("login.loginPlace")
                          },
                          domProps: { value: _vm.userName },
                          on: {
                            keydown: _vm.keydownAllSymbolExeptSpace,
                            change: _vm.deleteForbiddenChars,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.userName = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group" }, [
                          (_vm.isPasswordLoginVisible ? "text" : "password") ===
                          "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.passwordLogin,
                                    expression: "passwordLogin"
                                  }
                                ],
                                ref: "passwordLogin",
                                staticClass: "form-control",
                                class: { "is-invalid": _vm.msgError },
                                attrs: {
                                  name: "passwordLogin",
                                  placeholder: _vm.$t("login.passwordPlace"),
                                  type: "checkbox"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.passwordLogin)
                                    ? _vm._i(_vm.passwordLogin, null) > -1
                                    : _vm.passwordLogin
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.passwordLogin,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.passwordLogin = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.passwordLogin = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.passwordLogin = $$c
                                    }
                                  }
                                }
                              })
                            : (_vm.isPasswordLoginVisible
                                ? "text"
                                : "password") === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.passwordLogin,
                                    expression: "passwordLogin"
                                  }
                                ],
                                ref: "passwordLogin",
                                staticClass: "form-control",
                                class: { "is-invalid": _vm.msgError },
                                attrs: {
                                  name: "passwordLogin",
                                  placeholder: _vm.$t("login.passwordPlace"),
                                  type: "radio"
                                },
                                domProps: {
                                  checked: _vm._q(_vm.passwordLogin, null)
                                },
                                on: {
                                  change: function($event) {
                                    _vm.passwordLogin = null
                                  }
                                }
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.passwordLogin,
                                    expression: "passwordLogin"
                                  }
                                ],
                                ref: "passwordLogin",
                                staticClass: "form-control",
                                class: { "is-invalid": _vm.msgError },
                                attrs: {
                                  name: "passwordLogin",
                                  placeholder: _vm.$t("login.passwordPlace"),
                                  type: _vm.isPasswordLoginVisible
                                    ? "text"
                                    : "password"
                                },
                                domProps: { value: _vm.passwordLogin },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.passwordLogin = $event.target.value
                                  }
                                }
                              }),
                          _vm._v(" "),
                          _vm.passwordLogin
                            ? _c("div", { staticClass: "input-group-append" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline eye",
                                    attrs: { type: "button" },
                                    on: {
                                      click: _vm.changePasswordLoginVisibile
                                    }
                                  },
                                  [
                                    _vm.isPasswordLoginVisible
                                      ? _c("font-awesome-icon", {
                                          attrs: { icon: "eye" }
                                        })
                                      : _c("font-awesome-icon", {
                                          attrs: { icon: "eye-slash" }
                                        })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "enter-button row w-100",
                            attrs: {
                              disabled: _vm.disabledLogin,
                              type: "button"
                            },
                            on: { click: _vm.loginUser }
                          },
                          [
                            _vm._v(
                              "\r\n                            " +
                                _vm._s(_vm.$t("login.button")) +
                                "\r\n                        "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "crypto-download-link",
                    attrs: { href: "/dist/static/CryptoIntWS/CryptoIntWS.zip" }
                  },
                  [_vm._v(_vm._s(_vm.$t("login.linkToDownload")))]
                )
              ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-none" },
            _vm._l(_vm.frameUrls, function(frameUrl) {
              return _c("iframe", { attrs: { src: frameUrl, align: "left" } })
            })
          ),
          _vm._v(" "),
          _c("change-password-modal-component", {
            attrs: { userName: _vm.userName, password: _vm.passwordLogin },
            on: { login: _vm.loginGuest }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe359f5e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe359f5e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./login/components/login/login.html
// module id = 1152
// module chunks = 2